import React from "react";
import {
    formatAEMCashPrice,
    formatAEMCashPriceIsrael,
} from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { useBnbSelector } from "../../../../redux/store";

import * as Styles from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/CashPrice";
import { hideDiscountInfo } from "../../../../../../../common-deprecated/priceUtils";
import PricePromoIcon from "../../common/price/PricePromoIcon";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import Popover from "../../../../../../../common-deprecated/components/popover/aem/Popover";
import type { CashPricePropsType } from "./CashPrice";
import { getBnbPriceConfig } from "../../../../utils/settings/bnbFinanceSettingUtils";

const CashPriceIsrael = (props: CashPricePropsType & { cashPriceDisclaimer?: string }): JSX.Element | null => {
    const { price, cashPriceDisclaimer } = props;
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const modelCode = useBnbSelector((state) => state.car?.model?.internalCode || "");

    const priceConfig = getBnbPriceConfig(commonSettings, modelCode, NavStep.Model);

    const { highlight, discount, cash, promotions, licenseFee } = price;
    const cultureName = commonSettings.culture.name;

    if (!cash || !priceConfig.priceEnabled) return null;
    const hideDiscount = hideDiscountInfo(priceConfig);

    // Highlight is also a type of promotion which does not alter the price but should show the text as highlighted.
    if ((highlight || discount !== cash || promotions.length > 0) && !hideDiscount) {
        const cashFormatted = formatAEMCashPrice(cash, cultureName, priceConfig);
        const discountFormatted = formatAEMCashPrice(discount, cultureName, priceConfig, licenseFee);
        return (
            <Styles.PricesWrapper>
                <div>
                    <Styles.Text
                        dangerouslySetInnerHTML={{ __html: discountFormatted }}
                        isLarge={discount !== cash || promotions.length > 0}
                        mt={2}
                    />
                    {promotions.length > 0 && <PricePromoIcon promotions={promotions} />}
                </div>

                {!highlight && discount !== cash && (
                    <Styles.TextLineThrough dangerouslySetInnerHTML={{ __html: cashFormatted }} fontSize="13px" />
                )}
            </Styles.PricesWrapper>
        );
    }

    const cashFormatted = formatAEMCashPriceIsrael(
        hideDiscountInfo(priceConfig) ? discount : cash,
        cultureName,
        priceConfig,
        licenseFee,
        false,
    );

    return (
        <Styles.PricesWrapper>
            <Styles.Text>
                {cashFormatted.map((value, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <span key={index}>
                        <Styles.SpanText dangerouslySetInnerHTML={{ __html: value }} />
                        {/* Only render the disclaimer when there are more then 1 span elements and when a disclaimer is available. */}

                        {cashPriceDisclaimer && index === cashFormatted.length - 1 && cashFormatted.length > 1 && (
                            <Popover iconColor="primaryBlack" showOnClick content={cashPriceDisclaimer} useHTML />
                        )}
                    </span>
                ))}
            </Styles.Text>
        </Styles.PricesWrapper>
    );
};

export default CashPriceIsrael;
